module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content report-payout-list"
  }, [(_vm.source !== 'payout') ? _c('div', [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Submitted Payouts")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "width": "100%",
      "color": "rgba(0,0,0,0.12)",
      "margin-top": "10px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Payout Submitted")]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v(_vm._s(_vm.totalValues.submitted.actual) + " / " + _vm._s(_vm.totalValues.submitted.total))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0 subtitle-1"
  }, [_vm._v(_vm._s(_vm.totalValues.submitted.percent) + "%")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "border": "none"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('v-card-title', [_c('v-row', {
    staticStyle: {
      "justify-content": "right"
    }
  }, [(_vm.source == 'payout') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('date-picker', {
    attrs: {
      "className": "input-field",
      "options": {
        placeholder: 'Submission Date'
      },
      "date": _vm.searchFilters.submissionDate,
      "status": _vm.subDateCal
    },
    on: {
      "changeDate": _vm.setSubmissionDateFilter
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.source == 'payout') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('date-picker', {
    attrs: {
      "className": "input-field",
      "options": {
        placeholder: 'Due Date'
      },
      "date": _vm.searchFilters.dueDate,
      "status": _vm.dueDateCal
    },
    on: {
      "changeDate": _vm.setDueDateFilter
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    ref: "ReportPayoutListsTable",
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "search": _vm.filter
    },
    on: {
      "current-items": _vm.currentItems
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.name
          }, [_c('td', {
            staticClass: "report-payout-handle-column"
          }, [(item.platform === 'tiktok') ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.handle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.handle) + "\n                    ")]) : (item.platform === 'youtube') ? _c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://youtube.com/' + item.handle
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.handle))], 1) : (item.platform === 'facebook') ? _c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://facebook.com/' + item.handle
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(item.handle))], 1) : (item.platform === 'linkedin') ? _c('a', {
            attrs: {
              "target": "_blank",
              "href": _vm.linkedInProfileUrl(item)
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#0A66C2",
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.handle))], 1) : (item.platform === 'twitter') ? _c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://x.com/' + item.handle
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }), _vm._v(" @" + _vm._s(item.handle))]) : (item.platform === 'xiaohongshu') ? _c('a', {
            attrs: {
              "href": 'https://www.xiaohongshu.com/user/profile/' + item.xhsID,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/xhs-black.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.fullName || item.handle))]) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + item.handle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.handle || item.instagram) + "\n                    ")], 1)]), _vm._v(" "), _c('td', [(item.pending) ? _c('div', [_vm._v("\n                      -\n                    ")]) : _c('div', [_vm._v("\n                      " + _vm._s(_vm.changeDateFormat(item.createdAt)) + "\n                    ")])]), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [(item.pending) ? _c('div', [_vm._v("\n                      -\n                    ")]) : _c('div', [_vm._v("\n                      " + _vm._s(item.satisfaction_level_on_kobe) + " / 5\n                    ")])]), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [(item.pending) ? _c('div', [_vm._v("\n                      -\n                    ")]) : _c('div', [_vm._v("\n                      " + _vm._s(item.satisfaction_level_on_advertiser) + " / 5\n                    ")])]), _vm._v(" "), _c('td', {
            staticClass: "read-more-text"
          }, [(item.pending) ? _c('div', {
            staticClass: "pending-text"
          }, [_vm._v("\n                      -\n                    ")]) : _c('div', [(item.promotingProducts) ? _c('div', [_c('read-more', {
            attrs: {
              "more-str": "read more",
              "text": item.promotingProducts,
              "link": "#",
              "less-str": "read less",
              "max-chars": 50
            }
          })], 1) : _c('div', [_vm._v("\n                        Empty\n                      ")])])]), _vm._v(" "), _c('td', {
            staticClass: "read-more-text"
          }, [(item.pending) ? _c('div', {
            staticClass: "pending-text"
          }, [_vm._v("\n                      -\n                    ")]) : _c('div', [(item.improved) ? _c('div', [_c('read-more', {
            attrs: {
              "more-str": "read more",
              "text": item.improved,
              "link": "#",
              "less-str": "read less",
              "max-chars": 50
            }
          })], 1) : _c('div', [_vm._v("\n                        Empty\n                      ")])])]), _vm._v(" "), _c('td', {
            staticClass: "read-more-text"
          }, [(item.pending) ? _c('div', {
            staticClass: "pending-text"
          }, [_vm._v("\n                      -\n                    ")]) : _c('div', [(item.audienceEnjoyment) ? _c('div', [_c('read-more', {
            attrs: {
              "more-str": "read more",
              "text": item.audienceEnjoyment,
              "link": "#",
              "less-str": "read less",
              "max-chars": 50
            }
          })], 1) : _c('div', [_vm._v("\n                        Empty\n                      ")])])]), _vm._v(" "), _c('td', {
            staticClass: "read-more-text"
          }, [(item.pending) ? _c('div', {
            staticClass: "pending-text"
          }, [_vm._v("\n                      -\n                    ")]) : _c('div', [(item.otherCampaigns) ? _c('div', [_c('read-more', {
            attrs: {
              "more-str": "read more",
              "text": item.otherCampaigns,
              "link": "#",
              "less-str": "read less",
              "max-chars": 50
            }
          })], 1) : _c('div', [_vm._v("\n                        Empty\n                      ")])])]), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [(item.pending) ? _c('div', {
            staticClass: "pending-text"
          }, [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "color": "secondary",
              "small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.copyFormLink(item)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy Stats Submit Form")])], 1)], 1) : _c('div', [_c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  staticClass: "ims-action",
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "disabled": _vm.disableViewScreenshot(item)
                  },
                  on: {
                    "click": function($event) {
                      return _vm.viewImages(item)
                    }
                  }
                }, on), [_c('v-icon', [_vm._v("mdi-image-multiple")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Attached Screenshots")])])], 1)])])
        }), 0)]
      }
    }, {
      key: "no-results",
      fn: function() {
        return [_c('v-alert', {
          attrs: {
            "color": "error",
            "icon": "warning"
          }
        }, [_vm._v("\n                Your search for \"" + _vm._s(_vm.filter) + "\" found no results.\n              ")])]
      },
      proxy: true
    }])
  })], 1)])])])]), _vm._v(" "), _c('payout-screenshots-dialog', {
    attrs: {
      "value": _vm.viewScreenShotsDialog,
      "imagesToView": _vm.imagesToView
    },
    model: {
      value: (_vm.viewScreenShotsDialog),
      callback: function($$v) {
        _vm.viewScreenShotsDialog = $$v
      },
      expression: "viewScreenShotsDialog"
    }
  }), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.copySucceeded),
      callback: function($$v) {
        _vm.copySucceeded = $$v
      },
      expression: "copySucceeded"
    }
  }, [_vm._v("\n      Copied to Clipboard!\n      "), _c('v-btn', {
    attrs: {
      "color": "blue",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.copySucceeded = false
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-link"
    },
    domProps: {
      "value": _vm.formLink
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bf79829"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/ReportInternal/ReportPayoutLists.vue
// module id = 2214
// module chunks = 0